export default {
  hasPermission(currentRoute, permissionCode) {
    let permissionButton = currentRoute.meta.permission;
    return (
      permissionButton != null &&
      permissionButton[currentRoute.name + ":" + permissionCode] != null
    );
  },
  install(Vue, option) {
    Vue.prototype.$hasPermission = this.hasPermission;
  },
};
